<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    title: string;
    value: string | string[];
    isVisible?: any;
  }>(),
  {
    isVisible: true,
  },
);

const displayValue = computed(() =>
  Array.isArray(props.value) ? props.value.join(", ") : props.value,
);
</script>

<template>
  <span
    v-if="isVisible"
    class="inline-block bg-[#dbeafe] text-[#1e40af] px-2 py-[2px] rounded-full text-xs font-medium border border-[#bfdbfe]"
  >
    {{ title }}: {{ displayValue }}
  </span>
</template>
